module.exports = __webpack_public_path__ + "static/author-2-48e0d24db8509d29b98ca90aac9a02bc.jpg";